var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "jzliu-bi-engine-chart-warp",
    style: { height: _vm.warpHeight },
    attrs: { id: _vm.chartData._id },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }